import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import acessoIcon from "../../assets/icons/perfil.png";

import AcessosService from "../../services/AcessosService";
import CadastrosInternosService from "../../services/CadastrosInternosService";

export default function PermissaoAcessosForm({
  itemSelecionado,
  modo,
  onClose
}) {
  const [form, setForm] = useState({
    idCadastro: null,
    nomeCadastro: "",
    idAcesso: "",
    nomeAcesso: "",
  });

  const [permissao, setPermissao] = useState([]);
  const [permissoaSelecionada, setPermissaoSelecionada] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { setRetorno } = useGerenciamento();
  const [submitState, setSubmitState] = useState("IDLE"); 

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idCadastro: null,
        nomeCadastro: "",
        idAcesso: null,
        nomeAcesso: "",
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idCadastro: itemSelecionado.IDCADASTRO,
        nomeCadastro: itemSelecionado.NOME,
        idAcesso: itemSelecionado.IDACESSO || "",
        nomeAcesso: itemSelecionado.nome,
      });
    }
  }, [modo, itemSelecionado]);

  // ==========================
  // Carregar Permissões
  // ==========================

  useEffect(() => {
    async function carregarDados() {
      try {
        const perm = await AcessosService.getAll();
        setPermissao(perm);
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      }
    }
    carregarDados();
  }, []);

  // ==========================
  // Selecionar Permissão
  // ==========================
  function handleSelectPermissao(e){
    const idAcesso = Number(e.target.value);

      if (!idAcesso) {
      setPermissaoSelecionada(null);
      setForm(prev => ({ ...prev, idAcesso: "", nome: ""}));
      return;
    }

    const p = permissao.find(a => a.IDACESSO  === idAcesso);
    setPermissaoSelecionada(p);

    if (p) {
      setForm(prev => ({
        ...prev,
        idAcesso: p.IDACESSO ,
        nome: p.nome
      }));
    }
  }

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  }

  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};

    if (!form.nomeCadastro) e.nomeCadastro = "Informe o nome";
    if (!form.nomeAcesso) e.nomeAcesso = "Informe a permissão";
    return e;
  }

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);

    if (Object.keys(validation).length) return;

    setLoading(true);
    setSubmitState("IDLE");

    try {
      if (modo === "alterar") {

        const confirmacao = window.confirm(
            "Confirma a alteração da permissão de acesso?"
        );

        if (!confirmacao) {
            return;
        }

        const payload_update = {
             idCadastro: form.idCadastro,
             acesso: form.idAcesso
        };

        await CadastrosInternosService.updatePermissao(form.idCadastro, payload_update);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Acesso atualizado com sucesso!",
        });
        setSubmitState("SUCCESS");
      }

      if (modo === "novo") {
        setRetorno({
          tipo: "error",
          mensagem: "Módulo Inativo!",
        });
        setSubmitState("ERROR");
      }
       onClose();
    } catch (error) {
        setRetorno({
          tipo: "erro",
          mensagem:
            modo === "novo"
              ? "Erro ao criar Acesso."
              : "Erro ao atualizar Acesso.",
        });

        setSubmitState("ERROR");
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={acessoIcon} alt="Acesso" className="icon" />
          {modo === "novo" ? "Cadastro de acessos" : "Alterar acesso"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Nome: *</div>
            <input type="text" disabled  value={form.nomeCadastro}/>
        </div>

        {modo === "novo" && (
          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Permissão</div>
              <input type="text" disabled />
          </div> 
        )}


        {modo === "alterar" && (
            <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Permissão: *</div>
            <select
                value={form.idAcesso}
                onChange={handleSelectPermissao}
            >
                <option value="">Selecione uma Permissão</option>
                {permissao.map(p => (
                <option key={p.IDACESSO} value={p.IDACESSO}>
                    {p.nome}
                </option>
                ))}
            </select>
            </div>
        )}


        <div className="Form-Interno-alinhamento-button">
          {modo === "novo" && (
            <div /*type="submit" disabled={loading}*/
              className="Form-Interno-alinhamento-button-inativo" >
              {/*loading ? "Enviando..." : "Salvar"*/}
              <Link to="/Gerenciamento">Inativo</Link>
            </div>
          )}

          {modo === "alterar" && (
            <button type="submit" disabled={loading} className="Form-Interno-button">
              {loading ? "Enviando..." : "Salvar"}
            </button>
          )}

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
